import React, { useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';
import PropTypes from 'prop-types';

const IconList = ({
    disabled = false,
    onClick,
    size = 50,
    style,
    fill,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            height={size}
            fill={disabled ? '#cccccc' : fill}
            viewBox='0 0 50 50'
            onClick={onClick}
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...buildSvgEvents(ref, disabled, onClick, fill)}
            {...props}
        >
            <rect width={9.85} height={9.85} rx={1.52} />
            <path d='M48.48 0H20a1.52 1.52 0 00-1.52 1.52v6.81A1.52 1.52 0 0020 9.85h28.48A1.52 1.52 0 0050 8.33V1.52A1.52 1.52 0 0048.48 0zM48.48 20.07H20a1.53 1.53 0 00-1.52 1.53v6.8A1.53 1.53 0 0020 29.93h28.48A1.53 1.53 0 0050 28.4v-6.8a1.53 1.53 0 00-1.52-1.53z' />
            <rect y={20.07} width={9.85} height={9.85} rx={1.52} />
            <path d='M48.48 40.15H20a1.52 1.52 0 00-1.52 1.52v6.81A1.52 1.52 0 0020 50h28.48A1.52 1.52 0 0050 48.48v-6.81a1.52 1.52 0 00-1.52-1.52z' />
            <rect y={40.15} width={9.85} height={9.85} rx={1.52} />
        </svg>
    );
};

IconList.defaultProps = {
    disabled: false,
    size: 50
};

IconList.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.any,
    style: PropTypes.object
};

export default IconList;
